<template>
  <div class="brandDetail" :style="brandDetailStyle">
      <p class="title" :style="textStyle">{{ content.title }}</p>
      <p class="text" :style="textStyle">{{ content.text }}</p>
      <img :src="content.img&&content.img.url" alt="">
      <div class="box" v-if="(content.brand&&content.brand.show)||(content.price&&content.price.show)">
        <div v-if="content.brand&&content.brand.show">
          <p>品牌介绍</p>
          <p class="tips">Brand  introduction</p>
        </div>
        <div class="line" v-if="content.brand&&content.brand.show&&content.price&&content.price.show">/</div>
        <div v-if="content.price&&content.price.show">
          <p>价目表</p>
          <p class="tips">Project price</p>
        </div>
      </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'brandDetail',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        list: []
      },
      pattern: {},
      content: {},
    }
  },
  watch: {
  },
  computed: {
    brandDetailStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
        "background-color":this.pattern.bgColor
      }
    },
    textStyle(){
      return {
        "color":this.pattern.textColor
      }
    }
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      this.content = this.detailData.content || {}
      console.log("brandDetail----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.brandDetail{
  padding: 37px 20px 10px 20px;
  .title{
    // height: 22px;
    font-size: 22px;
    margin-bottom: 12px;
    font-weight: 700;
    text-align: center;
  }
  .text{
    font-size: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    margin-bottom: 23px
  }
  img{
    width: 100%;
    height: 160px;
    margin-bottom: 10px;
    object-fit: cover;
    border-radius: 15px;
  }
  .box{
    display: flex;
    width: 100%;
    height: 55px;
    background: #F6F6F6;
    border-radius: 37.75px;
    align-items: center;
    justify-content: center;
    .line{
      width: 5px;
      height: 14px;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
    }
    &>div{
      text-align: center;
      color: #333333;
      width: 140px;
      p{
        font-size: 13px;
        &.tips{
          font-size: 12px;
          zoom: 0.8;
          margin-top: 3px;
        }
      }
    }
  }
}
</style>
